import React from "react";
import { Box, Button, Typography, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

function ProfileReminder({ onClick, onDismiss }) {
  const handleClose = async () => {
    document.querySelector(".profile-reminder").style.display = "none";
    await onDismiss();
  };

  return (
    <Box
      sx={{
        position: "fixed",
        bottom: 0,
        left: 0,
        width: "100%",
        backgroundColor: "#d32f2f",
        color: "#fff",
        padding: "16px",
        boxShadow: "0 -2px 8px rgba(0, 0, 0, 0.2)",
        zIndex: 1000,
      }}
      className="flex flex-col md:flex-row gap-2 items-start md:items-center justify-between profile-reminder"
    >
      <Box>
        <Typography variant="h6" sx={{ fontWeight: 600 }}>
          Profile Incomplete
        </Typography>
        <Typography variant="body1">
          Please complete your profile to have more visibility and get best
          matches.
        </Typography>
      </Box>
      <Box className="justify-end">
        <Button
          variant="contained"
          color="error"
          onClick={onClick}
          sx={{ fontWeight: "bold", textTransform: "none" }}
        >
          Complete Profile
        </Button>
        <IconButton
          aria-label="Close"
          onClick={handleClose}
          sx={{ marginLeft: "16px" }}
        >
          <CloseIcon className="text-white" />
        </IconButton>
      </Box>
    </Box>
  );
}

export default ProfileReminder;
